import constants from '../constants';

const { VIEW_QUERY_PARAM } = constants;

export function deleteViewParam() {
  const url = new URL(location.href);
  const urlSearchParams = url.searchParams;
  urlSearchParams.delete(VIEW_QUERY_PARAM);
  url.search = urlSearchParams.toString();
  return url.href;
}

export function getViewKey(link: string): string {
  const url = new URL(link);
  return url.searchParams.get(VIEW_QUERY_PARAM);
}

type SavedViewUrlParts = Readonly<Pick<URL, 'search' | 'pathname'>>;

export function buildSavedViewLink(key: string, { search, pathname }: SavedViewUrlParts): string {
  const url = new URL(window.location.href);
  const urlSearchParams = new URLSearchParams(search);
  urlSearchParams.append(VIEW_QUERY_PARAM, key);
  url.pathname = pathname;
  url.search = urlSearchParams.toString();
  return url.href;
}
